





































import { Component, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import JobsearchRecruiteeSearchBox from "@/components/jobsearch/JobsearchRecruiteeSearchBox.vue";
import { JobsearchRecruiteeSearchParams } from "@/components/jobsearch/JobsearchRecruiteeSearchBox.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { PortalJobsearchRecruitee } from "@/model/portal";

@Component({
  components: {
    AppTextField,
    JobsearchRecruiteeSearchBox,
    AppAuthButton,
  },
})
export default class PortalRequestUserAgentLogin extends Mixins(
  AxiosMixin,
  UtilMixin
) {
  private searchKey = ""; //絞り込み文字列

  private recruitees: PortalJobsearchRecruitee[] = [];

  private headers = [
    { text: "選択", value: "action", width: "100px" },
    { text: "応募者番号（JST）", value: "jst_no" },
    { text: "iBowシステムID", value: "system_id" },
    { text: "名前", value: "name" },
  ];

  //データ取得
  private fetchList(searchObj: JobsearchRecruiteeSearchParams): void {
    this.postJsonCheck(
      window.base_url + "/api/admin/portal_jobsearch_recruitees/get",
      searchObj,
      (res) => {
        this.recruitees = res.data.recruitees || [];
      }
    );
  }

  //代理ログイン
  private login(id: number) {
    this.postJsonCheck(
      window.base_url +
        "/api/admin/portallogin/jobsearch-recruitee-agent-login",
      {
        recruitee_id: id,
      },
      (res) => {
        window.open(
          window.kaedoki_url +
            "/job-application/signin?token=" +
            res.data.onetime_token,
          "_blank"
        );
      }
    );
  }
}
